import React, {Component} from 'react';
import MessageBox from '../../Common/MessageBox';
import moment from 'moment-timezone';
import {Table} from '../../Common/PageComponents';

class IdSearchResult extends Component {
  render() {
    let result = new URLSearchParams(this.props.location.search);

    if (!result.get('userName')) {
      return <MessageBox>입력하신 정보와 일치하는 데이터가 없습니다.</MessageBox>;
    } else {
      return (
        <div style={{paddingTop: '30px'}}>
          <p className="inquiry">
            <b>1</b>개의 아이디가 검색되었습니다.
          </p>
          <Table>
            <colgroup>
              <col width="220" />
              <col width="287" />
              <col width="220" />
            </colgroup>
            <thead>
              <tr>
                <th>ID</th>
                <th>상호명</th>
                <th>가입일</th>
              </tr>
            </thead>
            <tbody>
              <tr key={result.get('userName')}>
                <td>{result.get('userName')}</td>
                <td>{result.get('pcBangName')}</td>
                <td>
                  {moment
                    .utc(result.get('created'))
                    .local()
                    .format('YYYY.MM.DD')}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      );
    }
  }
}

export default IdSearchResult;
